module.exports = __webpack_public_path__ + "img/lip.d7b9a16c.png";